// removed by extract-text-webpack-plugin
module.exports = {"default":"_1k-7U","red":"_3HY1A","black":"o8Uro","white":"_28al3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Helpers/StyledText/StyledTextComponents/Link.scss
 ** module id = 436
 ** module chunks = 0
 **/